import { createSelectorCreator, lruMemoize, weakMapMemoize } from 'reselect';

/**
 * App-wide selector creator for parameterized selectors (state, id, ...).
 *
 * Uses weakMapMemoize for argsMemoize (multi-arg caching)
 * and lruMemoize for the inner memoize layer (bounded, SSR-safe).
 *
 * The inner lruMemoize prevents memory leaks in SSR where shared
 * initialState references across stores would cause weakMapMemoize's
 * Map nodes for primitive args to accumulate indefinitely.
 *
 * Single-param (state) selectors don't need this — use createSelector directly.
 */
export const createAppSelector = createSelectorCreator({
    argsMemoize: weakMapMemoize,
    memoize: lruMemoize,
    memoizeOptions: { maxSize: 1 },
});
